import { defineMessages } from 'react-intl';

export const scope = 'app.components.EditPlayerAssessment';

export const messages = defineMessages({
  errPositionNotSaved: {
    id: `${scope}.errPositionNotSaved`,
    defaultMessage: "The position wasn't changed. Please try again."
  },
});
